import { render, staticRenderFns } from "./policyTpl.vue?vue&type=template&id=528b75e6&"
import script from "./policyTpl.vue?vue&type=script&lang=js&"
export * from "./policyTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports